<template>
  <div>
    <div v-if="httpError && httpError.length" class="alert alert-danger">
      <div v-for="(error, i) in httpError" :key="i">
        {{ capitalize(error.message) }}.
      </div>
    </div>

    <form method="post" @submit.prevent="handleFormSubmit">
      <div class="form-group">
        <label for="firstName">First Name</label>
        <input
          id="firstName"
          type="text"
          v-model="user.firstName"
          name="firstName"
          class="form-control"
          v-validate="'required'"
          data-vv-as="first name"
        />
        <small v-if="veeErrors.has('firstName')" class="text-danger">
          {{ veeErrors.first("firstName") }}
        </small>
      </div>
      <div class="form-group">
        <label for="lastName">Last Name</label>
        <input
          id="lastName"
          type="text"
          v-model="user.lastName"
          name="lastName"
          class="form-control"
          v-validate="'required'"
          data-vv-as="last name"
        />
        <small v-if="veeErrors.has('lastName')" class="text-danger">
          {{ veeErrors.first("lastName") }}
        </small>
      </div>
      <div class="form-group">
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          v-model="user.email"
          name="email"
          class="form-control"
          v-validate="'required'"
        />
        <small v-if="veeErrors.has('email')" class="text-danger">
          {{ veeErrors.first("email") }}
        </small>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="password">Password</label>
            <input
              id="password"
              type="password"
              ref="password"
              v-model="user.password"
              name="password"
              class="form-control"
              v-validate="'required'"
            />
            <small v-if="veeErrors.has('password')" class="text-danger">
              {{ veeErrors.first("password") }}
            </small>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="password2">Confirm Password</label>
            <input
              id="password2"
              type="password"
              name="password2"
              class="form-control"
              v-validate="'required|confirmed:password'"
              data-vv-as="password"
            />
            <small v-if="veeErrors.has('password2')" class="text-danger">
              {{ veeErrors.first("password2") }}
            </small>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ActionButton
            type="submit"
            :theme="{
              primary,
              secondary,
              event,
              danger
            }"
            :disabled="isLoading || !!veeErrors.items.length"
            label="Save"
            style="width: auto; margin-left: auto; margin-top: 0;"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import serializeError from "serialize-error";
import Color from "color";
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/base";

export default {
  name: "AddTenantUser",
  components: {
    ActionButton
  },
  props: {
    tenant: {
      type: Object,
      default: () => ({})
    },
    roles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoading: true,
      user: {},
      error: null,
      httpError: null
    };
  },
  mounted() {
    this.isLoading = false;
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    async handleFormSubmit() {
      this.clearErrors();
      this.isLoading = true;

      try {
        const isValid = await this.handleFormValidations();

        if (!isValid) {
          throw Error("Unable to validate form.");
        }

        const UserRoles = this.roles
          .filter(role => role.value === 8)
          .map(role => ({ roleId: role.id }));

        const background = Math.floor(Math.random() * 16777215).toString(16);
        const color = Color("#" + background).isLight ? "fff" : "333";
        const firstName = this.user.firstName.replace(/ .*/, "");
        const lastName = this.user.lastName.replace(/ .*/, "");
        const user = {
          ...this.user,
          displayName: firstName,
          avatar: `https://ui-avatars.com/api/?name=${firstName}+${lastName}&background=${background}&color=${color}&size=500&font-size=.35&bold=true`,
          UserRoles
        };
        const response = await axios.post("/users", user, {
          headers: {
            "X-Request-Origin": this.tenant.id + ".headroomapp.com"
          }
        });

        // TODO: Send mail notification

        if (response.status === 200) {
          this.$root.$emit("superadmin-userlist:fetchUsers");
          this.$toastr.success(`${user.email} has been added.`);
          this.$emit("close");
        } else {
          this.$toastr.error("Unable to save add user. Try again.");
        }
        this.isLoading = false;
      } catch (error) {
        const err = serializeError(error);
        if (err.response) {
          this.httpError = err.response.data.errors[0].errors;
        } else {
          this.error = err;
        }
        this.isLoading = false;
      }
    },
    handleFormValidations() {
      return this.$validator.validateAll().then(isValid => isValid);
    },
    capitalize(str) {
      if (typeof str !== "string") return "";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    clearErrors() {
      this.error = this.httpError = null;
    }
  }
};
</script>

<style lang="scss" scoped></style>
